import React from 'react';
import { DialogWrapper, DialogWrapperType } from '../dialog';
// import QRCode from 'qrcode.react';
import { Box } from '@material-ui/core';

export interface QRCodeDialogProps {
 value: string;
 open: boolean;
 color?: string;
 onClose(): void;
}

export const QRCodeDialog = ({ value, open, onClose }: QRCodeDialogProps) => (
 <DialogWrapper title='Scan QR code' open={open} onClose={onClose} type={DialogWrapperType.DEFAULT}>
  <Box display='flex' justifyContent='center' width='100%'>
   {/* <QRCode value={value} size={200} fgColor={color} /> */}
   <img src={`${value}?q=${Date.now()}`} alt='qr-code' />
  </Box>
 </DialogWrapper>
);
